import React from 'react';

interface FlexProps {
  children: React.ReactNode;
  className?: string;
  direction?: 'row' | 'column';
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around';
  alignItems?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around';
}

export function Flex({
  children,
  className,
  direction = 'row',
  justifyContent = 'flex-start',
  alignItems = 'center',
}: FlexProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: direction,
        justifyContent,
        alignItems,
      }}
      className={className}
    >
      {children}
    </div>
  );
}
